class Vueapi {
    constructor(core){

        this.core = core
        this.store = this.core.store
        this.router = this.core.vm.$router
        this.vm = core.vm

    }

    icon = function(icon, message){
        this.store.commit('icon', {
            icon,
            message
        })
    }

    articlestatic = function(data, events, p = {}){

        this.store.commit('OPEN_MODAL', {
            id: 'modal_articlestatic',
            module: "articlestatic",
            caption: "",
            mclass : "withoutheader",
            data : data,
            events
        })

    }

    coursecreate = function(data, events, p = {}){

        this.store.commit('OPEN_MODAL', {
            id: 'modal_coursecreate',
            module: "coursecreate",
            caption: "",
            mclass : "withoutheader",
            data,
            events
        })

    }

    catalog = function(data, events, p = {}){

        this.store.commit('OPEN_MODAL', {
            id: 'modal_catalog',
            module: "catalog",
            caption: "",
            mclass : "withoutheader",
            data,
            events
        })
    }

    sharesocial = function(data, p = {}){

        this.store.commit('OPEN_MODAL', {
            id: 'modal_sharesocial',
            module: "sharesocial",
            caption: p.caption || this.core.i18n.t('caption.share'),
            mclass : 'small',
            data : data
        })

    }

    setpayment = function(data, events){

        this.store.commit('OPEN_MODAL', {
            id: 'modal_setpayment',
            module: "setpayment",
            caption: this.core.i18n.t('caption.setpayment'),
            data : data,
            events
        })

    }

    cdvpayment = function(data, events){

        this.store.commit('OPEN_MODAL', {
            id: 'modal_cdvpayment',
            module: "cdvpayment",
            caption: this.core.i18n.t('caption.setpayment'),
            data : data,
            events
        })

    }

    partnerinfo = function(data, events){

        this.store.commit('OPEN_MODAL', {
            id: 'modal_partnerinfo',
            module: "partnerinfo",
            caption: "",
            data : data,
            events
        })

    }

    paymentinfo = function(data, events){

        this.store.commit('OPEN_MODAL', {
            id: 'modal_paymentinfo',
            module: "paymentinfo",
            caption: "",
            data : data,
            events
        })

    }

    share = function(data, p = {}){

        this.store.commit('OPEN_MODAL', {
            id: 'modal_share',
            module: "share",
            caption: p.caption || this.core.i18n.t('caption.share'),
            mclass : 'small',
            data : data
        })

    }

    pincode = function(mode = 'create', attemp, check, caption){

        var hascode = false

        return new Promise((resolve, reject) => {

            this.store.commit('OPEN_MODAL', {
                id : 'modal_pincode',
                module : "pincode",
                mclass : 'withoutheader',
                data : {
                    confirm : mode == 'create',
                    mode,
                    attemp,
                    check,
                    caption
                },
                events : {
                    success : function(pin){

                        hascode = true

                        resolve(pin)
                    },
                    close : function(){

                        if(!hascode){
                            hascode = true
                            reject()
                        }

                    }
                }
            })

        })

        
    }

    camera = function(success, p = {}){
        this.store.commit('OPEN_CAMERA', {
            data : {
                multiple : true,
                mask : {
                    title : p.title || ""
                }
            },
            events : {
                selected : (images) => {
                    success(images)
                }
            }
        })
    }

    fx = function({place, name, parameters = {}}){

        var dp = {}

        if (name == 'stars') 
            dp = {
                opacity : 0.8,
                scatter : 20,
                duration : 900,
                color : '#ffa000'
            }

        this.store.commit('FX', {place, name, parameters : {
            ...dp,
            ...parameters
        }})
    }

    fxinfinity = function(){
        this.store.commit('FX', {infinity : true})
    }

  


    ///

    customWindow = function(module, caption, data = {}, events = {}, p = {}){

        var e = false

        return new Promise((resolve, reject) => {

            events.close = () => {

                if(e) return

                e = true
                reject('closed')
            }

            events.success = (d) => {

                if(e) return

                e = true
                resolve(d)
            }

            this.store.commit('OPEN_MODAL', {
                id : 'modal_' + module,
                module : module,
                caption : caption || "",
                data : data,
                events : events,
                mclass : p.mclass,
            })
        })

    }

    explore = function(data, events){

        this.store.commit('OPEN_MODAL', {
            id : 'modal_explore',
            module : "explore",
            caption : "",
            mclass : 'withoutheader',
            data : data,
            events : events
        })

    }

    fastmenu = function(){

        this.store.commit('OPEN_MODAL', {
            id : 'modal_fastmenu',
            module : "fastmenu",
            caption : "",
            mclass : 'withoutheader fastmenu absoluteContent',
        })

    }

    listmenu = function(items, events){
        this.store.commit('OPEN_MODAL', {
            id : 'modal_listmenu',
            module : "listmenu",
            caption : "",
            mclass : 'small likemenu',

            data :  {
                items,
                close : () => {
                    this.store.commit('CLOSE_MODAL', 'modal_listmenu')
                }
            },

            events
        })
    }

    listmenupromise = function(items, events = {}){


        return new Promise((resolve, reject) => {

            events.close = () => {
                reject('closed')
            }

            this.store.commit('OPEN_MODAL', {
                id : 'modal_listmenu',
                module : "listmenu",
                caption : "",
                mclass : 'small likemenu',
                
                data :  {
                    items,
                    
                },
                events
            })
        })
    }


    gallery = function(images = [], index = 0){

        this.store.commit('GALLERY', {
            images,index
        })

    }

    mediaplayer = function(data, events){
        this.store.commit('OPEN_MODAL', {
            id : 'mediaplayer',
            module : "mediaplayer",
            one : true,
            data,
            events
        })
    }

    edit = function(data, events){
        this.store.commit('OPEN_MODAL', {
            id : 'modal_edit',
            module : "edit",
            caption : "",
            data : data,
            events
        })
    } 

    bday = function(data, events){
        this.store.commit('OPEN_MODAL', {
            
            id : 'modal_bday',
            module : "bday",
            caption : "",
            noswipe : true,
            data : {
                ...data,
            },
            events
        })
    } 

    setpicture = function(data, events){
        this.store.commit('OPEN_MODAL', {
            
            id : 'modal_setpicture',
            module : "setpicture",
            caption : "",
            data : data,
            events
        })
    } 

    taskdata = function(data, events){
        this.store.commit('OPEN_MODAL', {
            
            id : 'modal_taskdata',
            module : "taskdata",
            mclass : 'withoutheader',
            caption : "",
            data,
            events
        })
    } 


    locale = function(data, events){
        this.store.commit('OPEN_MODAL', {
            
            id : 'modal_locale',
            module : "locale",
            caption : "",
            data : {
                ...data,
            },
            events
        })
    } 

    playlist = function(data, events){
        this.store.commit('OPEN_MODAL', {
            id : 'playlist',
            module : "playlist",
            mclass : 'withoutheader',
            data,
            events
        })
    }

    privacy = function(data, events){
        this.store.commit('OPEN_MODAL', {
            id : 'privacy',
            module : "privacy",
            data,
            caption: this.core.i18n.t('caption.privacy'),
            events
        })
    }

    terms = function(data, events){
        this.store.commit('OPEN_MODAL', {
            id : 'terms',
            module : "terms",
            data,
            caption: this.core.i18n.t('caption.terms'),
            events
        })
    }

    story = function(data, events){
        this.store.commit('OPEN_MODAL', {
            id : 'story',
            module : "story",
            mclass : 'withoutheader',
            data,
            events
        })
    }

    storytext = function(data, events){
        this.store.commit('OPEN_MODAL', {
            id : 'storytext',
            module : "storytext",
            mclass : 'withoutheader',
            data,
            events
        })
    }




    htmlpage = function (srcdoc, events = {}) {
        this.store.commit('OPEN_MODAL', {
            id : 'modal_htmlpage',
            module : "htmlpage",
            data : {srcdoc},
            mclass : 'absoluteContent allscreen aiwindow',
            customscroll : true
        })
    }

    multimediagallery = function (data, events) {
        this.store.commit('OPEN_MODAL', {
            id : 'modal_mediagallery',
            module : "multimediagallery",
            data : data,
            mclass : 'mediagallerywindow ' + (!this.core.mobileview() ? 'allscreen' : ''),
            events : events,
            one : true,
        })
    }

    
}

export default Vueapi